module.exports = __webpack_public_path__ + "img/inspiration_styles@2x.5d37502.webp";